import React, { useEffect, useMemo, useState } from "react";
import Header from "../components/Header";
import BottomNav from "../components/BottomNav";
import ContestCard from "../components/ContestCard";
import { getContests } from "../lib/api";
import { Filter } from "lucide-react";

const CATS = [
  { v: "all", l: "All" },
  { v: "bollywood", l: "Bollywood" },
  { v: "reality", l: "Reality" },
  { v: "creator", l: "Creator" },
  { v: "music", l: "Music" },
  { v: "athletes", l: "Athletes" },
];

const MODES = [
  { v: "all", l: "All Modes" },
  { v: "daily", l: "Daily" },
  { v: "weekly", l: "Weekly" },
  { v: "season", l: "Season" },
];

export default function Contests() {
  const [contests, setContests] = useState([]);
  const [cat, setCat] = useState("all");
  const [mode, setMode] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getContests({ category: cat, mode }).then(setContests).finally(() => setLoading(false));
  }, [cat, mode]);

  const live = useMemo(() => contests.filter(c => c.status === "live"), [contests]);
  const upcoming = useMemo(() => contests.filter(c => c.status === "upcoming"), [contests]);

  return (
    <div className="min-h-screen pb-safe" data-testid="contests-page">
      <Header title="Contests" />
      <div className="max-w-xl mx-auto px-4 pt-4">
        <div className="flex items-center gap-2 mb-3">
          <Filter className="w-4 h-4 text-white/50" />
          <p className="text-xs tracking-widest uppercase text-white/50 font-bold">Filters</p>
        </div>

        <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
          {CATS.map((c) => (
            <button
              key={c.v}
              data-testid={`filter-cat-${c.v}`}
              onClick={() => setCat(c.v)}
              className={`chip whitespace-nowrap px-3 py-1.5 text-xs ${cat === c.v ? "" : "opacity-60"}`}
              style={cat === c.v
                ? { background: "linear-gradient(90deg,#B026FF,#00F0FF)", color: "#000", border: "1px solid transparent" }
                : { background: "rgba(255,255,255,0.05)", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" }}
            >
              {c.l}
            </button>
          ))}
        </div>
        <div className="flex gap-2 overflow-x-auto py-2 -mx-1 px-1">
          {MODES.map((m) => (
            <button
              key={m.v}
              data-testid={`filter-mode-${m.v}`}
              onClick={() => setMode(m.v)}
              className={`chip whitespace-nowrap px-3 py-1.5 text-xs ${mode === m.v ? "" : "opacity-60"}`}
              style={mode === m.v
                ? { background: "#00FF6622", color: "#00FF66", border: "1px solid #00FF6655" }
                : { background: "rgba(255,255,255,0.05)", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" }}
            >
              {m.l}
            </button>
          ))}
        </div>

        <section className="mt-4 space-y-4">
          {loading && <p className="text-white/50 text-sm">Loading contests…</p>}
          {!loading && live.length > 0 && (
            <>
              <h2 className="font-display text-xl font-bold">● Live</h2>
              {live.map((c) => <ContestCard key={c.contest_id} contest={c} />)}
            </>
          )}
          {!loading && upcoming.length > 0 && (
            <>
              <h2 className="font-display text-xl font-bold mt-4">Upcoming</h2>
              {upcoming.map((c) => <ContestCard key={c.contest_id} contest={c} />)}
            </>
          )}
          {!loading && contests.length === 0 && (
            <p className="text-white/50 text-sm">No contests match your filters.</p>
          )}
        </section>

        <div className="h-10" />
      </div>
      <BottomNav />
    </div>
  );
}
